import React from "react";
import { Link } from "gatsby";
import { Container } from "../components/Container";

import Layout from "../components/layout";
import SEO from "../components/seo";
import reactLogo from "../assets/react.svg";
import typescriptLogo from "../assets/typescript.svg";
import graphqlLogo from "../assets/graphql.svg";

import redisLogo from "../assets/redis.svg";
import nodeLogo from "../assets/node.svg";
import postgres from "../assets/postgres.svg";
const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Container>
      <article
        style={{
          padding: "40px 0 20px 0",
        }}
      >
        <h2>What I bring to the table</h2>
        <section>
          <h3 className="section-heading">Frontend Development</h3>
          <p>
            The frontend world is continuously evolving. To be successful in the
            landscape of current frontend technology, one needs to be ready to
            rethink and relearn.
          </p>
          <p>
            However, there's also never been a better time to be a software
            engineer. The release of new frameworks, libraries, and tools, both
            from large companies and the contributions of the open-source
            community enables an extremely effective and productive developer
            pipeline. What used to take a whole team of developers months can
            today be handled by a single developer, provided they keep up to
            date with the latest technologies.
          </p>
          <h4>My preferred frontend stack</h4>
          <ul>
            <li>React - A JavaScript library for building user interfaces </li>
            <li>
              React Native - Enables the creation of native apps for Android and
              iOS{" "}
            </li>
            <li>GraphQL - A Query Language for APIs </li>
            <li>
              Typescript - A scalable, less error-prone way to write Javascript
              with types{" "}
            </li>
            <li>
              GatsbyJS/NextJS - React frameworks that simplify performance, SEO
              and tooling.
            </li>
          </ul>
        </section>
        <div className="logo-section">
          <img src={reactLogo} alt="React" className="logo" />
          <img src={typescriptLogo} alt="Typescript" className="logo" />
          <img src={graphqlLogo} alt="GraphQL" className="logo" />
        </div>
        <section>
          <h3 className="section-heading">Backend Development</h3>
          <p>
            Similar to the frontend, backend technologies have not remained
            stagnant. One could argue that there's even greater variation in how
            developers approach the backend.
          </p>
          <p>
            Some relatively recent trends are the rise of GraphQL APIs, the
            importance of AI and machine learning, microservices, realtime user
            experiences, web security, containerization, and serverless
            technologies.
          </p>

          <h4>My preferred backend stack</h4>
          <ul>
            <li>
              NodeJS - A Javascript runtime enabling backends to be written with
              Javascript
            </li>
            <li>GraphQL - A Query Language for APIs</li>
            <li>
              MySQL/ PostgreSQL - Relational databases remain crucial to the
              modern backend, yet face some competition from document-based,
              NoSQL type databases
            </li>
            <li>Redis - Caching and message broker</li>
          </ul>
          <div className="logo-section">
            <img src={nodeLogo} alt="Node" className="logo" />
            <img src={redisLogo} alt="Redis" className="logo" />
            <img src={postgres} alt="Postgres" className="logo" />
          </div>
        </section>
        <section>
          <h3 className="section-heading">Devops, deployment and tooling</h3>
          <ul>
            <li>Cloud providers, Linux, Nginx</li>
            <li>Git</li>
            <li>Docker</li>
          </ul>
        </section>
      </article>
    </Container>
  </Layout>
);

export default IndexPage;
